import React, { Component, useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import { useParams } from "react-router-dom";
import { request } from "../../utils/request";
import { getSucursal } from "../../utils/helpers";
import { ReplacementVariable } from "./ReplacementVariable";
import 'quill/dist/quill.snow.css';

const PrintCarta = () => {
    const { id } = useParams();

    const [carta, setCarta] = useState();
    const [loading, setLoading] = useState(false);
    const [sucursal, setSucursal] = useState();
    const [safeHtml, setSafeHtml] = useState("");

    const getCarta = async () => {
        setLoading(true);

        const res = await request("cartas/" + id);

        setCarta(res.data);

        setLoading(false);
    };

    useEffect(() => {
        if (!carta) return;

        const unsafeHtml = ReplacementVariable[carta?.template?.tipo].reduce(
            (html, item) => html.replace(`{{ ${item.value} }}`, item.generate(carta.contacto ?? {}) ?? ""),
            carta?.template?.content ?? ""
        );
        setSafeHtml(DOMPurify.sanitize(unsafeHtml));
    }, [carta]);

    // Espera a que el HTML sanitizado ya esté en el DOM antes de imprimir.
    useEffect(() => {
        if (safeHtml) {
            window.print();
        }
    }, [safeHtml]);

    useEffect(() => {
        getCarta();

        const sucursalInfo = JSON.parse(localStorage.getItem("user"));
        setSucursal(
            sucursalInfo.sucursales.find(
                (sucursal) => sucursal.id === getSucursal()
            )
        );
    }, []);

    return <div className="p-2 invoice recibo-print">
        <div className="clear-both p-t-30">
            <div className="row">
                <div className="ml-0 mr-auto">
                    {sucursal?.logo && <img
                        alt="logo"
                        className="mb-2 factura-logo"
                        src={sucursal.logo[0].url}
                        width="270px"
                    />}
                </div>

                <div className="ml-auto mr-0 my-auto text-right">
                    <h3 style={{ lineHeight: "12px", marginBottom: "3px" }}>{sucursal?.nombre}</h3>

                    <div
                        className="mb-0 mb-md-0"
                        style={{ lineHeight: "15px", fontSize: "13px" }}
                    >
                        RNC: {sucursal?.rnc} TEL.:{sucursal?.telefono}
                    </div>
                    <div
                        className="mb-2 mb-md-0"
                        style={{ lineHeight: "15px", fontSize: "13px" }}
                    >
                        {sucursal?.direccion}
                    </div>
                </div>
            </div>
        </div>

        <div className="mt-2 ql-editor" dangerouslySetInnerHTML={{ __html: safeHtml }}></div>
    </div>;
};

export default PrintCarta;
